document.addEventListener('DOMContentLoaded', function () {
  new Swiper('.grez-slider', {
    slidesPerView: 1,
    spaceBetween: 20,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    breakpoints: {
      768: {
        slidesPerView: 2.5
      },
      1024: {
        slidesPerView: 3.35
      }
    }
  });
});